import { createEvent } from 'effector';

export const saveChatPublicHexagonsEv = createEvent();

export const applyChatPublicHexagonsEv = createEvent();

export const revertChatPublicFiltersEv = createEvent();
